import React from "react";
import { AuthContext } from "features/auth/contexts";

export const useAuth = () => React.useContext(AuthContext);
